export default {
  'Cases types': 'TIPOS DE CAIXAS',
  'Possible contents of the case': 'Possíveis conteúdos da caixa',
  'Other cases': 'OUTRAS CAIXAS',
  'Open for': 'Abrir para',
};
